<template>
  <v-container fluid>
    <v-btn color="primary" to="/firmwares/new">
      펌웨어 등록
      <v-icon right>mdi-plus</v-icon>
    </v-btn>
    <v-data-iterator
      :items="items"
      :server-items-length="count"
      :options="pagination"
      :loading="loading"
      @update:page="move"
      :footer-props="{
        'disable-items-per-page': true,
        'items-per-page-options': []
      }"
    >
      <template v-slot:default="{ items }">
        <v-row>
          <template v-for="firmware in items">
            <v-col
              :key="firmware.id"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <v-card>
                <v-card-title>
                  {{ firmware.originalname }}
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pb-0">
                  <v-row no-gutters>
                    <v-col cols="6">대상 모델</v-col>
                    <v-col cols="6">{{ firmware.modelNo }}</v-col>
                    <v-col cols="6">대상 유형</v-col>
                    <v-col cols="6">{{ firmware.deviceType }}</v-col>
                    <v-col cols="6">버전</v-col>
                    <v-col cols="6">{{ firmware.version }}</v-col>
                    <v-col cols="6">데이터 분할</v-col>
                    <v-col cols="6">{{ firmware.div }}</v-col>
                    <v-col cols="12">
                      <div class="pt-2">
                        {{ firmware.description }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-btn outlined :to="'/firmwares/' + firmware.id + '/fota'">
                    <v-icon left>mdi-cloud-upload-outline</v-icon>
                    포타 요청
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="edit(firmware.id)"><v-icon>mdi-pencil</v-icon></v-btn>
                  <v-btn v-if="false" icon @click="download(firmware.url)"><v-icon>mdi-download</v-icon></v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
import { getFirmwares } from '@/api'
import { getPaginationParams, downloadFrom } from '@/utils'

export default {
  data () {
    return {
      firmwares: [],
      count: 0,
      loading: false,
      pagination: {
        page: 1,
        itemsPerPage: 12
      }
    }
  },
  computed: {
    items () {
      return this.firmwares.map(firmware => firmware)
    }
  },
  async beforeRouteEnter (to, from, next) {
    let page = parseInt(to.query.page, 10) || 1
    if (page < 1) page = 1

    const params = getPaginationParams(to, { itemsPerPage: 12 })
    try {
      const { items, count } = await getFirmwares(params)

      next(vm => {
        vm.firmwares = items
        vm.count = count
        vm.pagination.page = page
      })
    } catch (err) {
      next()
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      await this.fetch(to)
      next()
    } catch (err) {
      next()
    }
  },
  methods: {
    async fetch (route) {
      this.loading = true
      const params = getPaginationParams(route, { itemsPerPage: 12 })

      try {
        const { items, count } = await getFirmwares(params)

        this.firmwares = items
        this.count = count
      } finally {
        this.loading = false
      }
    },
    move (page) {
      if (page !== this.pagination.page) {
        this.pagination.page = page
        this.$router.push({ query: { ...this.$route.query, page } })
      }
    },
    edit (id) {
      this.$router.push(`/firmwares/${id}/edit`)
    },
    download (url) {
      downloadFrom(url)
    }
  }
}
</script>
